<template>
    <v-container class="p-relative">

        <!-- TOOLBAR -->
        <step-dots :step="step" can-skip @back="goBack" @skip="finishStepper(true)"/>

        <!-- CAROUSEL -->
        <v-carousel :show-arrows="false" light hide-delimiters touchless v-model="carousel" height="100%"
                    class="overflow-visible">
            <!-- BASIC INFO -->
            <v-carousel-item>
                <basic-info-stepper @change="basicInfoData"/>
            </v-carousel-item>
            <!-- SPORT RECORD -->
            <v-carousel-item>
                <sport-record stepper-mode @change="sportRecordData"/>
            </v-carousel-item>
            <!-- OBJECTIVE WITH BUILDER -->
            <v-carousel-item>
                <choose-objectives @change="objectivesArray = $event"/>
            </v-carousel-item>
            <!-- PLACE OF TRAINING -->
            <v-carousel-item>
                <place-training @change="selectedPlace = $event"/>
            </v-carousel-item>
            <!-- EQUIPMENT AVAILABLE -->
            <v-carousel-item>
                <choose-equipments-stepper @change="equipmentsArray = $event"/>
            </v-carousel-item>
        </v-carousel>

        <v-row class="container-bottom">
            <v-col cols="12" lg="6">
                <v-btn @click="continueStepper" color="primary" class="black--text normal-btn" depressed large block
                       right :loading="overlay">
                    {{ $t('common.continue') }}
                </v-btn>
            </v-col>
            <v-col cols="12" lg="6">
                <logout-button outlined color="black" large block/>
            </v-col>
        </v-row>

        <v-overlay z-index="50" :value="overlay">
            <v-progress-circular color="primary" indeterminate size="64"/>
        </v-overlay>

    </v-container>
</template>

<script>
import {db} from '@/utils/Firebase'
import {mapActions} from 'vuex'
import StepDots from "@/components/entrance/elements/StepDots";
import BasicInfoStepper from "@/components/entrance/elements/BasicInfoStepper";
import SportRecord from "@/components/student/SportRecord";
import ChooseObjectives from "@/components/student/ChooseObjectives";
import PlaceTraining from "@/components/student/PlaceTraining";
import ChooseEquipmentsStepper from "@/components/student/ChooseEquipmentsStepper";
import LogoutButton from "@/components/common/inputs/LogoutButton";

export default {
    components: {
        LogoutButton,
        StepDots,
        BasicInfoStepper,
        SportRecord,
        ChooseObjectives,
        PlaceTraining,
        ChooseEquipmentsStepper,
    },
    data() {
        return {
            carousel: 0,
            overlay: false,
            // Step 1
            name: '',
            phone: '',
            birthDate: '',
            gender: '',
            country: '',
            // Step 2
            height: '',
            weight: '',
            trainingDays: 0,
            sportSelected: '',
            // Step 3
            objectivesArray: [],
            // Step 4
            selectedPlace: [],
            // Step 5
            equipmentsArray: [],
        }
    },
    computed: {
        step(vm = this) {
            return vm.carousel + 1
        },
    },
    methods: {
        basicInfoData(payload) {
            const vm = this
            vm.name = payload.name || ''
            vm.phone = payload.phone || ''
            vm.birthDate = payload.birthDate || ''
            vm.gender = payload.gender || ''
            vm.country = payload.country || ''
        },
        sportRecordData(payload) {
            const vm = this
            vm.height = payload.height || ''
            vm.weight = payload.weight || ''
            vm.trainingDays = payload.trainingDays || 0
            vm.sportSelected = payload.sportSelected || ''
        },
        continueStepper() {
            const vm = this
            if (vm.carousel === 0 && (!vm.name || (!vm.phone || vm.phone.length < 8))) return vm.toast(vm.$t('entrance.required_name_phone'), 'error')
            if (vm.carousel !== 4) return vm.carousel++
            vm.finishStepper()
        },
        async finishStepper(skip = false) {
            const vm = this
            let payload = {}
            vm.overlay = true

            if (skip) {
                if (vm.carousel === 0 && (!vm.name || (!vm.phone || vm.phone.length < 8))) {
                    vm.overlay = false
                    return vm.toast(vm.$t('entrance.required_name_phone'), 'error')
                }

                payload.name = vm.name
                payload.phone = vm.phone
            } else {
                // Step 1
                if (vm.name) payload.name = vm.name
                if (vm.phone) payload.phone = vm.phone
                if (vm.birthDate) payload.birthDate = vm.birthDate
                if (vm.gender) payload.gender = vm.gender
                if (vm.country) payload.country = vm.country
                // // Step 2
                if (vm.height !== '') payload.height = vm.height
                if (vm.weight !== '') payload.weight = vm.weight
                payload.trainingDays = vm.trainingDays + 1
                if (vm.sportSelected) payload.sportSelected = vm.sportSelected?.name || vm.sportSelected
                // // Step 3
                if (vm.objectivesArray.length > 0) payload.objectives = JSON.parse(JSON.stringify(vm.objectivesArray))
                // // Step 4
                if (vm.selectedPlace.length > 0) payload.places = JSON.parse(JSON.stringify(vm.selectedPlace))
                // // Step 5
                if (vm.equipmentsArray.length > 0) payload.equipments = JSON.parse(JSON.stringify(vm.equipmentsArray))
            }

            // console.log('payload', payload);

            await db.collection('users').doc(vm.currentUser.uid).update(payload)
            vm.$emit('finish')
            vm.overlay = false
        },
        goBack() {
            const vm = this
            if (vm.carousel === 0) return
            return vm.carousel--
        }
    },
}
</script>

<style scoped>

.container-bottom {
    position: sticky;
    bottom: 0;
    margin-top: 4px;
    background-color: #FFFFFF;
}

::v-deep .v-carousel__item {
    overflow: visible !important
}

</style>